import { render, staticRenderFns } from "./ContentBlockPartialCTAs.vue?vue&type=template&id=2ce625d5&scoped=true&"
import script from "./ContentBlockPartialCTAs.vue?vue&type=script&lang=js&"
export * from "./ContentBlockPartialCTAs.vue?vue&type=script&lang=js&"
import style0 from "./ContentBlockPartialCTAs.vue?vue&type=style&index=0&id=2ce625d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce625d5",
  null
  
)

export default component.exports